/* esm.sh - tailwindcss@3.4.19/plugin */
export * from "/*tailwindcss@3.4.19/esnext/plugin.mjs";
export { default } from "/*tailwindcss@3.4.19/esnext/plugin.mjs";
